import { eEstadoMaestro } from "../common/enumModel";
import { IFilterTipoEmpleadoModel } from "../interfaces/tipo-empleado/IFilterTipoEmpleadoModel";

export class FilterTipoEmpleadoModel implements IFilterTipoEmpleadoModel {    
    idTipoEmpleado: number[];
    nombre: string;
    idEstado: eEstadoMaestro;
    page: number;
    pageSize: number;
    
    constructor(){
        this.idTipoEmpleado = new Array<number>();
        this.nombre = '';
        this.idEstado = eEstadoMaestro.ACTIVO;
        this.page = 1;
        this.pageSize = 30;
    }
}